import { render, staticRenderFns } from "./IconFilePng.vue?vue&type=template&id=7c136fee"
import script from "./IconFilePng.vue?vue&type=script&lang=js"
export * from "./IconFilePng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports